
import {
    onMounted,
    reactive,
    ref,
    defineComponent,
    getCurrentInstance,
} from 'vue'
import { UsePageDto } from '@/common/mixins/listPageDto'
import { getList } from './request'
import formatDate from '@/common/functions/formatDate'
import { message, Modal } from 'ant-design-vue'
import { useStore } from 'vuex'
import SetMenu from './components/SetMenu.vue'

export default defineComponent({
    components: {
        SetMenu,
    },
    setup() {
        const store = useStore()
        const instance = getCurrentInstance()
        const { pagination, listPageDto, handleTableChange } = UsePageDto(
            instance
        )
        const loading = ref<boolean>(false)
        const data = ref([])
        const columns = [
            {
                title: '版本 ID',
                dataIndex: 'id',
                key: 'id',
            },
            {
                title: '渠道名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                dataIndex: 'action',
                title: '操作',
                slots: { customRender: 'action' },
                width: 200,
            },
        ]
        // 获取列表
        const fetchList = async () => {
            const params = {
                pageDto: {
                    pageNum: listPageDto.pageNum,
                    pageSize: listPageDto.pageSize,
                },
            }
            loading.value = true
            try {
                const res = await getList(params)
                loading.value = false
                data.value = res.data
                Object.assign(listPageDto, res.pageDto)
            } catch (e) {
                console.error(e)
                loading.value = false
            }
        }

        const configMenuAction = (record: any) => {
            store.commit('setVersionDetail', record)
            store.commit('toggleVersionSetMenuState', true)
        }
        onMounted(() => {
            fetchList()
        })
        return {
            data,
            columns,
            store,
            fetchList,
            configMenuAction,
            formatDate,
            loading,
            handleTableChange,
        }
    },
})
